import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { IssueTableFilterSchema } from './_list/-zod-schema';

export const Route = createFileRoute('/_stacktrace/issues/_layout/')({
  validateSearch: zodValidator(IssueTableFilterSchema),
});
